module.exports = __webpack_public_path__ + "img/Alien_symbol_0.882f33fe.png";